// Orange = Food
// Purple = Shopping
// Pink = Hangout Spots

const data = {
  info: [
    {
      name: 'Artichoke Basille’s Pizza',
      type: 'Late night',
      coordinates: [37.867971974372644, -122.25682735915225],
      color: '#fcc988',
      link: 'https://www.artichokepizza.com/location/artichoke-basille-pizza-berkeley/',
    },
    {
      name: 'Mezzo',
      type: 'Lunch',
      coordinates: [37.86630654150992, -122.25851194499367],
      color: '#fcc988',
      link: 'https://www.mezzo-berkeley.com',
    },
    {
      name: 'Sliver Pizzeria',
      type: 'Lunch',
      coordinates: [37.870202354323766, -122.2677602520181],
      color: '#fcc988',
      link: 'https://www.sliverpizzeria.com',
    },
    {
      name: 'Super Duper Burgers',
      type: 'Lunch',
      coordinates: [37.86783796586084, -122.258595780323],
      color: '#fcc988',
      link: 'https://www.superduperburgers.com/location/berkeley/',
    },
    {
      name: 'Tacos Sinaloa',
      type: 'Lunch',
      coordinates: [37.86760861389282, -122.25893903408492],
      color: '#fcc988',
      link: 'https://tacossinaloaoakland.com',
    },
    {
      name: 'Sweetgreen',
      type: 'Lunch',
      coordinates: [37.87402319013602, -122.26884720089355],
      color: '#fcc988',
      link: 'https://www.sweetgreen.com',
    },
    {
      name: "Gypsy's Trattoria Italiana",
      type: 'Dinner',
      coordinates: [37.86807136858306, -122.25817572844822],
      color: '#fcc988',
    },
    {
      name: 'Homeroom',
      type: 'Dinner',
      coordinates: [37.82857019332056, -122.25994572095863],
      color: '#fcc988',
      link: 'https://homeroom510.com',
    },
    {
      name: 'Berkeley Thai House',
      type: 'Dinner',
      coordinates: [37.86713062214572, -122.25828901681264],
      color: '#fcc988',
      link: 'https://www.berkeley-thaihouse.com',
    },
    {
      name: 'Delhi Diner',
      type: 'Dinner',
      coordinates: [37.86669617071139, -122.259008004119],
      color: '#fcc988',
      link: 'https://delhidiner.net',
    },
    {
      name: "La Val's Pizza",
      type: 'Dinner',
      coordinates: [37.87553089065567, -122.26036927040379],
      color: '#fcc988',
      link: 'http://www.lavals.com',
    },
    {
      name: 'Toss',
      type: 'Dinner',
      coordinates: [37.86799318843059, -122.26814369856285],
      color: '#fcc988',
      link: 'https://www.tossnoodlebar.onthemenu.us',
    },
    {
      name: 'Abe’s Pizza',
      type: 'Late night',
      coordinates: [37.867974993449714, -122.25922271751965],
      color: '#fcc988',
      link: 'http://www.abespizza.com',
    },
    {
      name: 'Top Dog',
      type: 'Late night',
      coordinates: [37.86781528931116, -122.25737226110974],
      color: '#fcc988',
      link: 'http://topdoghotdogs.com',
    },
    {
      name: 'Free Speech Movement Cafe',
      type: 'Coffee',
      coordinates: [37.87254835233477, -122.2608587299573],
      color: '#fcc988',
      link: 'https://www.lib.berkeley.edu/about/fsm-cafe',
    },
    {
      name: 'Caffe Strada',
      type: 'Coffee',
      coordinates: [37.86915001427439, -122.25486426289315],
      color: '#fcc988',
      link: 'https://caffestradaberkeley.mybistro.online',
    },
    {
      name: 'Cafenated Coffee Company',
      type: 'Coffee',
      coordinates: [37.880235509221606, -122.26989673195504],
      color: '#fcc988',
      link: 'https://cafe.cafenated.co',
    },
    {
      name: "Yali's Cafe",
      type: 'Coffee',
      coordinates: [37.87345182748643, -122.26635089098578],
      color: '#fcc988',
      link: 'https://www.yaliscafe.com',
    },
    {
      name: 'Berkeley Social Club',
      type: 'Weekend brunch',
      coordinates: [37.871879067266505, -122.2694919284425],
      color: '#fcc988',
      link: 'https://www.berkeley-socialclub.com',
    },
    {
      name: 'The Sunny Side Cafe',
      type: 'Weekend brunch',
      coordinates: [37.87015611949473, -122.26600872768014],
      color: '#fcc988',
      link: 'https://www.thesunnysidecafe.com',
    },
    {
      name: 'Cafe Durant',
      type: 'Weekend brunch',
      coordinates: [37.8680697596795, -122.2582792292164],
      color: '#fcc988',
      link: 'https://www.cafedurant.com',
    },
    {
      name: 'Downtown Berkeley Farmers\' Market',
      type: 'Groceries',
      coordinates: [37.87014071787513, -122.27137893581364],
      color: '#a0a9d0',
      link: 'https://ecologycenter.org/fm/',
    },
    {
      name: 'Berkeley Bowl',
      type: 'Groceries',
      coordinates: [37.85721368417646, -122.26732328420637],
      color: '#a0a9d0',
      link: 'https://www.berkeleybowl.com',
    },
    {
      name: 'Moe’s Books',
      type: 'Bookshop',
      coordinates: [37.86550985464304, -122.25865972539556],
      color: '#a0a9d0',
      link: 'https://www.moesbooks.com',
    },
    {
      name: 'Books Inc.',
      type: 'Bookshop',
      coordinates: [37.88039155908043, -122.26904116488915],
      color: '#a0a9d0',
      link: 'https://www.booksinc.net',
    },
    {
      name: 'Bancroft Clothing Co.',
      type: 'Clothes',
      coordinates: [37.86870072016292, -122.25834897198432],
      color: '#a0a9d0',
      link: 'https://www.bancroftclothing.com',
    },
    {
      name: 'Indigo Vintage Co-op',
      type: 'Clothes',
      coordinates: [37.86496382115376, -122.25828963384309],
      color: '#a0a9d0',
      link: 'https://www.indigovtg.com/about',
    },
    {
      name: 'Memorial Glade',
      type: 'Hangout spot',
      coordinates: [37.87319486585549, -122.25943454321775],
      color: '#ec9792',
      link: 'https://www.berkeley.edu/map?memglade',
    },
    {
      name: 'Campanile',
      type: 'Hangout spot',
      coordinates: [37.872065799105094, -122.25780693781543],
      color: '#ec9792',
      link: 'https://visit.berkeley.edu/the-campanile/',
    },
    {
      name: 'Grizzly Peak',
      type: 'Hangout spot',
      coordinates: [37.88222079418566, -122.23364616653186],
      color: '#ec9792',
      link: 'https://en.wikipedia.org/wiki/Grizzly_Peak_(Berkeley_Hills)',
    },
    {
      name: 'Cesar Chavez Park',
      type: 'Hangout spot',
      coordinates: [37.872095463536176, -122.31888070161556],
      color: '#ec9792',
      link: 'https://www.cityofberkeley.info/Parks_Rec_Waterfront/Trees_Parks/Parks__Cesar_Chavez_Park.aspx',
    },
    {
      name: 'Willard Park',
      type: 'Hangout spot',
      coordinates: [37.86110522996339, -122.25640481549706],
      color: '#ec9792',
      link: 'https://www.cityofberkeley.info/Parks_Rec_Waterfront/Trees_Parks/Parks__Willard_Park.aspx',
    },
  ],
  minLat: 37.8503526,
  maxLat: 37.899434,
  minLong: -122.3256618,
  maxLong: -122.2319033,
};

export default data;
